import { RootState } from "shared/types";

export const selectIntercomConversations = () => (state: RootState) =>
  Object.values(state.local_monitoring.intercom);

export const selectIntercomConversationCountByUserId = (userId: string) => (state: RootState) =>
  Object.values(state.local_monitoring.intercom).filter(
    (conversation) => conversation.user_id === userId,
  ).length;

export const selectMonitoringEventTableEventsPerPage = () => (state: RootState) =>
  state.local_monitoring?.monitoring_event_table_events_per_page;

export const selectMonitoringEventTableLevels = () => (state: RootState) =>
  state.local_monitoring?.monitoring_event_table_levels;

export const selectMonitoringEventTableTypes = () => (state: RootState) =>
  state.local_monitoring?.monitoring_event_table_types;

export const selectMonitoringEventTableUsers = () => (state: RootState) =>
  state.local_monitoring?.monitoring_event_table_users;

export const selectStartTimeFilter = () => (state: RootState) =>
  state.local_monitoring?.start_time_filter;

export const selectEndTimeFilter = () => (state: RootState) =>
  state.local_monitoring?.end_time_filter;

export const selectTimeFilter = () => (state: RootState) => [
  state.local_monitoring?.start_time_filter,
  state.local_monitoring?.end_time_filter,
];
